import { Capacitor } from '@capacitor/core';
import { useEffect } from 'react';

/**
 * useStatusBarSync
 *
 * Keeps the Android status bar style and background colour in sync with the
 * app's active light / dark theme.
 *
 * Light theme → Style.Light  (dark icons on light bg)  background #8B80F9 (matches light mockup header)
 * Dark  theme → Style.Dark   (light icons on dark bg)  background #19191A (matches dark mockup)
 *
 * Runs only on native platforms — a no-op on web.
 */
export function useStatusBarSync(theme: 'light' | 'dark'): void {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    // Dynamically import to keep the web bundle free of native dependencies
    import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
      if (theme === 'light') {
        // Purple bar (#8B80F9): use light content so icons are visible (matches light mockup header)
        StatusBar.setStyle({ style: Style.Light }).catch(() => {});
        StatusBar.setBackgroundColor({ color: '#8B80F9' }).catch(() => {});
      } else {
        StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
        StatusBar.setBackgroundColor({ color: '#19191A' }).catch(() => {});
      }
    }).catch(() => {});
  }, [theme]);
}
